<template> 
  <div id="wrapper" :class="{ 'cliente-layout': isClienteUser }" :style="wrapperStyle">
    <div class="page-loader-wrapper" v-if="isLoading">
        <div class="loader">
          <div class="m-t-30"><img src="./assets/logo-icon.svg" width="48" height="48" alt="Lucid"></div>
          <p>Caricamento in corso...</p>
        </div>
    </div> 
    <HeaderComponent v-if="!hideAdminChrome" />
    <SidebarComponent v-if="!hideAdminChrome" />
    <router-view :style="routerViewStyle"></router-view>
  </div>
</template>
<script>
import HeaderComponent from './components/admin/layouts/HeaderComponent.vue'
import SidebarComponent from './components/admin/layouts/SidebarByteRivo.vue'
import { useAuthStore } from './stores/auth'

export default {
  name: 'App',
  components: {
    HeaderComponent,
    SidebarComponent
  },
  computed: {
    hideAdminChrome() {
      const hiddenRouteNames = ['login', 'register','lockscreen','fpassword','404','403','500','503','maintanance','home'];
      return hiddenRouteNames.includes(this.$route.name) || this.$route.path === '/progetto-finanziato';
    },
    isAdminUser() {
      const authStore = useAuthStore()
      return authStore.hasPermission('admin.access')
    },
    isClienteUser() {
      const authStore = useAuthStore()
      return !this.isAdminUser && authStore.isLoggedIn
    },
    wrapperStyle() {
      return {
        backgroundColor: document.body.className.includes('theme-blue') ? '#f5f5f5' : undefined
      }
    },
    routerViewStyle() {
      // Aggiungi margin-left se la sidebar è visibile (admin users)
      if (this.isAdminUser && !this.hideAdminChrome) {
        return { marginLeft: '250px' }
      }
      return {}
    }
  },
  watch: {
    $route: {
      immediate: true, // also trigger handler on initial value
      handler() {
        try{
          if (this.$route.name === 'maintanance') {
            document.body.className = '';
          } else {
            // Leggi i valori dal localStorage
            let storedTheme = localStorage.getItem('byterivo:theme') || '';
            let storedColor = localStorage.getItem('byterivo:color') || 'blue';
            
            // Valida il colore - se non è uno dei valori validi, usa 'blue' e cancella il localStorage
            const validColors = ['blue', 'green', 'purple', 'orange', 'cyan', 'khaki', 'coral', 'salmon', 'blush', 'seagreen', 'amber', 'turquoise', 'pink'];
            if (!validColors.includes(storedColor)) {
              storedColor = 'blue';
              try { localStorage.removeItem('byterivo:color'); } catch(e) { /* ignore */ }
            }
            
            // Per i clienti, forza sempre il tema blue
            if (this.isClienteUser) {
              storedColor = 'blue';
              storedTheme = '';
            }
            
            document.body.className = 'theme-' + storedColor + ' ' + storedTheme;
          }
        }catch(e){
          // fallback safe default
          document.body.className = 'theme-blue';
        }
      }
    }   
  },methods:{
    
  },data (){
      return{
        isLoading: true,
      }
  },created(){
         // Imposta il tema blu di default all'avvio (SUBITO, prima di tutto)
         document.body.className = 'theme-blue';
         
         this.interval = setInterval(() => {
            this.isLoading = false
        }, 3000);
    }
}
</script>
<style lang="scss">
  @import '../src/assets/vendor/bootstrap/css/bootstrap.min.css';
  @import '../src/assets/vendor/font-awesome/css/font-awesome.min.css';
  @import '../src/assets/scss/main.scss';
  @import '../src/assets/scss/color_skins.scss';
  @import '../node_modules/vue-multiselect/dist/vue-multiselect.css';

  // Stili per layout cliente (senza sidebar)
  #wrapper.cliente-layout {
    margin-left: 0 !important;
    padding-left: 0 !important;
  }

  #wrapper.cliente-layout #main-content {
    margin-left: 0 !important;
    padding: 20px;
  }

  // Assicura che il router-view abbia il padding corretto quando la sidebar è visibile
  #wrapper:not(.cliente-layout) {
    #main-content:not(.landing-page),
    > .page,
    > [id="main-content"] {
      margin-left: 250px !important;
      padding-bottom: 60px;
    }
  }
  
  // Landing page occupa tutto lo schermo
  .landing-page {
    margin: 0 !important;
  }
</style>
